import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import ApprovalPage from "./pages/ApprovalPage";
import CustomerApprovalsPage from "./pages/CustomerApprovalsPage";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/approve/:approvalId" element={<ApprovalPage />} />
        <Route path="/customer-approvals" element={<CustomerApprovalsPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  </React.StrictMode>
);
